module.exports = "/static/assets/3cfc9b39a0d002246119d47f6756d77e.svg";